import { render, staticRenderFns } from "./AddRolesManual.vue?vue&type=template&id=9ada9658&scoped=true&"
import script from "./AddRolesManual.vue?vue&type=script&lang=js&"
export * from "./AddRolesManual.vue?vue&type=script&lang=js&"
import style0 from "./AddRolesManual.vue?vue&type=style&index=0&id=9ada9658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ada9658",
  null
  
)

export default component.exports